import { CheckoutDetails } from '@ancon/wildcat-types'
import getFormattedCurrency from '@ancon/wildcat-utils/currency/getFormattedCurrency'

import { GiftCardPurchaseCartSummary } from '../types'

function getSubtotalExclTaxAmount(checkout: CheckoutDetails): string {
  return getFormattedCurrency(
    checkout.subtotalExclTax.amount,
    checkout.subtotalExclTax.currency,
    {
      trimTrailingZeros: false,
      showAsManyDecimalsAsNeeded: true,
    },
  )
}

function getSubtotalInclTaxAmount(checkout: CheckoutDetails): string {
  return getFormattedCurrency(
    checkout.subtotalInclTax.amount,
    checkout.subtotalInclTax.currency,
    {
      trimTrailingZeros: false,
      showAsManyDecimalsAsNeeded: true,
    },
  )
}

function getTaxAmount(checkout: CheckoutDetails): string {
  return getFormattedCurrency(
    checkout.taxAmount.amount,
    checkout.taxAmount.currency,
    {
      trimTrailingZeros: false,
      showAsManyDecimalsAsNeeded: true,
    },
  )
}

function getDiscountAmount(checkout: CheckoutDetails): string | null {
  if (!checkout.subTotalDiscountInclTax?.amount) {
    return null
  }

  return getFormattedCurrency(
    checkout.subTotalDiscountInclTax.amount,
    checkout.subTotalDiscountInclTax.currency,
    {
      trimTrailingZeros: false,
      showAsManyDecimalsAsNeeded: true,
    },
  )
}

function getTotalAmount(checkout: CheckoutDetails): string {
  const { currency, amount } = checkout.totalAmount

  return getFormattedCurrency(amount, currency, {
    trimTrailingZeros: false,
    showAsManyDecimalsAsNeeded: true,
  })
}

function getGiftCardPurchaseCartSummaryFromCheckout(
  checkout: CheckoutDetails,
): GiftCardPurchaseCartSummary {
  const subtotalExclTaxAmount = getSubtotalExclTaxAmount(checkout)

  const subtotalInclTaxAmount = getSubtotalInclTaxAmount(checkout)

  const discountAmount = getDiscountAmount(checkout)

  const taxAmount = getTaxAmount(checkout)

  const totalAmount = getTotalAmount(checkout)

  return {
    subtotalExclTaxAmount,
    subtotalInclTaxAmount,
    discountAmount,
    taxAmount,
    totalAmount,
  }
}

export default getGiftCardPurchaseCartSummaryFromCheckout
